import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import { Formik, Form, Field } from 'formik'
import yup from 'yup'

import WarningIcon from '@components/Icon/Warning'
import InfoBox from '@components/InfoBox'
import Input from '@components/Form/Input'
import RichTextEditor from '@components/Form/RichTextEditor'
import Button from '@components/Button'

class EmailTemplatesForm extends Component {
  static propTypes = {
    template: PropTypes.object,
    modalStore: PropTypes.object,
    emailTemplatesStore: PropTypes.object
  }

  static defaultProps = {
    hideButtons: true,
    showCloseIcon: true,
    shouldCloseOnOverlayClick: true,
    wideContent: true
  }

  handleSubmit = (values, actions) => {
    const { template, modalStore, emailTemplatesStore } = this.props

    return emailTemplatesStore
      .update(template.id, values)
      .then(emailTemplatesStore.getAll)
      .then(modalStore.close)
      .catch(({ message }) => {
        this.error = message
        actions.setSubmitting(false)
      })
  }

  validationSchema = yup.object().shape({
    subject: yup
      .string()
      .required('Subject field is required')
      .typeError('Subject field is required'),
    content: yup
      .string()
      .required('Content field is required')
      .typeError('Content field is required')
  })

  render() {
    const { modalStore } = this.props
    const { name, subject, content, placeholders } = this.props.template

    return (
      <div className="email-template-form-wrapper">
        <Formik
          enableReinitialize
          initialValues={{ subject, content }}
          validationSchema={this.validationSchema}
          onSubmit={this.handleSubmit}
          render={form => (
            <div className="expert-form">
              <Form onSubmit={form.handleSubmit}>
                <h2 className="expert-form__subtitle">
                  Edit template - {name}
                </h2>
                {this.error ? (
                  <InfoBox theme="red" icon={<WarningIcon />}>
                    {this.error}
                  </InfoBox>
                ) : null}
                <Field name="subject" label="Subject" component={Input} />
                <Field
                  name="content"
                  label="Content"
                  component={RichTextEditor}
                />
                <div className="expert-form__section">
                  <Button
                    primary
                    submit
                    onClick={this.onSubmit}
                    disabled={form.isSubmitting}>
                    Save
                  </Button>
                  <Button
                    onClick={() => {
                      modalStore.close()
                    }}>
                    Cancel
                  </Button>
                </div>
              </Form>
              <InfoBox className="placeholders" icon={null}>
                <h3>Placeholders</h3>
                <div dangerouslySetInnerHTML={{ __html: placeholders }} />
              </InfoBox>
            </div>
          )}
        />
      </div>
    )
  }
}

export default inject(
  'modalStore',
  'emailTemplatesStore'
)(observer(EmailTemplatesForm))
